/** Static banner assets for major categories (slug → public path). */
export const CATEGORY_BANNER_IMAGES: Record<string, string> = {
  body: "/images/category-banners/body.png",
  fragrance: "/images/category-banners/fragrance.png",
  hair: "/images/category-banners/hair.png",
  "room-scents": "/images/category-banners/room-scents.png",
  makeup: "/images/category-banners/makeup.png",
  "oral-care": "/images/category-banners/oral-care.png",
  skin: "/images/category-banners/skin.png",
  toys: "/images/category-banners/toys.png",
  fashion: "/images/category-banners/fashion.png",
  home: "/images/category-banners/home.png",
  clothing: "/images/category-banners/clothing.png",
  pets: "/images/category-banners/pets.png",
  parapharmacy: "/images/category-banners/parapharmacy.png",
  beverages: "/images/category-banners/beverages.png"
};

/** Categories with missing slug in DB (id → banner path). */
export const CATEGORY_ID_BANNER_IMAGES: Record<number, string> = {
  19: "/images/category-banners/health-personal-care.png"
};

export function categoryBannerImage(slug: string, categoryId: number): string | null {
  if(slug && CATEGORY_BANNER_IMAGES[slug]) return CATEGORY_BANNER_IMAGES[slug];
  return CATEGORY_ID_BANNER_IMAGES[categoryId] ?? null;
}
